import react, { useState, useEffect } from "react";
import useWindowSize from "./useWindowSize";
function useSizePercentage() {
  const [sizePercentage, setSizePercentage] = useState({
    total: 0,
    width: 0,
    height: 0,
  });
  const [maxSize, setMaxSize] = useState({ total: 0, width: 0, height: 0 });
  const windowSize = useWindowSize();

  function setTotalPercentage() {
    const pixels = windowSize.width * windowSize.height;
    if (
      pixels > maxSize.total &&
      windowSize.width > maxSize.width &&
      windowSize.height > maxSize.height
    )
      setMaxSize({
        ...maxSize,
        total: pixels,
        width: windowSize.width,
        height: windowSize.height,
      });
    else if (pixels > maxSize.total && windowSize.width > maxSize.width)
      setMaxSize({ ...maxSize, total: pixels, width: windowSize.width });
    else if (pixels > maxSize.total && windowSize.height > maxSize.height)
      setMaxSize({ ...maxSize, total: pixels, height: windowSize.height });
    else if (windowSize.height > maxSize.height)
      setMaxSize({ ...maxSize, height: windowSize.height });
    else if (windowSize.width > maxSize.width)
      setMaxSize({ ...maxSize, width: windowSize.width });

    const totalPercentage = Math.round((pixels / maxSize.total) * 100);
    const widthPercentage = Math.round(
      (windowSize.width / maxSize.width) * 100
    );
    const heightPercentage = Math.round(
      (windowSize.height / maxSize.height) * 100
    );

    if (maxSize.total != 0) {
      setSizePercentage({
        ...sizePercentage,
        total: totalPercentage,
        width: widthPercentage,
        height: heightPercentage,
      });
    }
  }

  useEffect(() => {
    setTotalPercentage();
  }, [windowSize]);

  return sizePercentage;
}

export default useSizePercentage;
